import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Planner from "@/pages/Planner";
import Goals from "@/pages/Goals";
import Mood from "@/pages/Mood";
import PrintView from "@/pages/PrintView";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-500">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/app"
              element={
                <Protected>
                  <AppShell />
                </Protected>
              }
            >
              <Route index element={<Planner />} />
              <Route path="planner" element={<Planner />} />
              <Route path="goals" element={<Goals />} />
              <Route path="mood" element={<Mood />} />
            </Route>
            <Route
              path="/print"
              element={
                <Protected>
                  <PrintView />
                </Protected>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
